import DataTable from "../../../components/Table";
import type { ColumnsType } from "antd/es/table";
import { Row, Col, Button, Space, Popconfirm, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import PermissionSearch from "./PermissionSearch";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
// import { fetchPermission } from "../../../redux/slice/permissionSlice";
import AddPermission from "./add";
import { callDeletePermission } from "../../../config/api";
import ModalPermission from "./edit";
import { fetchPermission } from "../../../redux/slice/permissionSlide";
import DateFormat from "../../../utils/formatTime/DateFormat";
import { FORMAT_DATE_DISPLAY } from "../../../utils/constants/timeFormat";
import ViewDetail from "./detail/ViewDetail";

interface DataType {
  key: React.Key;
  idTopic: string;
  idPermission: string;
  description: string;
  image: string;
}
function ManagePermission() {
  const [searchPagination, setSearchPagination] = useState(
    "current=1&pageSize=5"
  );
  const [searchData, setSearchData] = useState("");
  const dispatch = useAppDispatch();
  const [dataViewDetail, setDataViewDetail] = useState("");
  const [openViewDetail, setOpenViewDetail] = useState(false);
  const permissions = useAppSelector((state) => state.permission);

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "_id",
      render: (text, record: any) => {
        return (
          <span
            style={{color: "#4986ff", cursor: "pointer"}}
            onClick={() => {
              setDataViewDetail(record);
              setOpenViewDetail(true);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "API Path",
      dataIndex: "apiPath",
    },
    {
      title: "Method",
      dataIndex: "method",
    },
    {
      title: "Module",
      dataIndex: "module",
    },
    {
      title: "CreatedAt",
      dataIndex: "createdAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "UpdatedAt",
      dataIndex: "updatedAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      render: (_, record: any) => (
        <Space size="middle">
          <ModalPermission
            id={record._id}
            handleFetchPermission={handleFetchPermission}
          />
          <Popconfirm
            placement="leftTop"
            title={"Xác nhận xóa user"}
            description={"Bạn có chắc chắn muốn xóa user này ?"}
            onConfirm={() => handleDeletePermission(record._id)}
            okText="Xác nhận"
            cancelText="Hủy">
            <Button type="primary" danger ghost>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  let query = `${searchPagination}${searchData}`;

  const handleDeletePermission = async (id: string) => {
    const result = await callDeletePermission(id);
    if (result.statusCode === 200) {
      handleFetchPermission();
      message.success("delete success!");
    } else {
      message.error("delete failed!");
    }
  };

  const handleFetchPermission = () => {
    dispatch(fetchPermission({ query }));
  };
  useEffect(() => {
    handleFetchPermission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleModalCreate = (): JSX.Element => {
    return (
      <>
        <AddPermission handleFetchPermission={handleFetchPermission} />
      </>
    );
  };

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <PermissionSearch handleSearch={setSearchData} />
        </Col>
      </Row>
      <DataTable
        columns={columns}
        data={permissions?.result}
        total={permissions?.meta.total}
        loading={permissions.isFetching}
        modalAdd={handleModalCreate}
        name={"Permissions"}
        setSearchPagination={setSearchPagination}
      />
      <ViewDetail
        openViewDetail={openViewDetail}
        dataViewDetail={dataViewDetail}
        setOpenViewDetail={setOpenViewDetail}
      />
    </>
  );
}

export default ManagePermission;
